// extracted by mini-css-extract-plugin
export default {"label":"PropertyLocation_label__TOU0v","group":"PropertyLocation_group__YsiyS","locationGroup":"PropertyLocation_locationGroup__NT2A2","location":"PropertyLocation_location__XfzOJ"};